import { Dispatch, SetStateAction } from 'react'
import { EmailErrorType } from 'shared/components/dashboard-mail-editor/types/email-interface'
import { TLocoType } from 'shared/hooks/use-loco-translation'
import { isValidEmail } from 'shared/utils/email-validation'

export const validateEmailBeforeSave = <T extends EmailErrorType>(
  email: string,
  setErrors: Dispatch<SetStateAction<T>>,
  t: TLocoType,
) => {
  if (!isValidEmail(email)) {
    setErrors(
      prev =>
        prev && {
          ...prev,
          fromEmail: t('dashboard.validation.email_not_valid'),
        },
    )
    throw new Error(t('dashboard.validation.email_not_valid'))
  }
}
